module.exports = __webpack_public_path__ + "static/media/745MeldrumStNW_2018-06-18_122.d79fdc2e.jpg";